import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor() {
    (window as any).NG_SHARED_TRANSLATION_SERVICE = this;
  }

  init() {

  }

  async translateHtml(html: string): Promise<Response> {
    return this.translateFromTo(null, null, null, html);
  }

  async translate(text: string): Promise<Response> {
    return this.translateFromTo(null, null, text, null);
  }

  async translateHtmlTo(toLocale: string, html: string): Promise<Response> {
    return this.translateFromTo(null, toLocale, null, html);
  }

  async translateTo(toLocale: string, text: string): Promise<Response> {
    return this.translateFromTo(null, toLocale, text, null);
  }

  async translateFromTo(fromLocale: string, toLocale: string, text: string, html: string): Promise<Response> {

    const body: any = {
      fromLocale: fromLocale,
      toLocale: toLocale,
    };

    if (text) {
      body.text = text;
    }

    if (html) {
      body.html = html;
    }

    let result = await fetch("_support/translate", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }
    );

    let tr = await result.json();


    return tr.translation;
  }
}
